// extracted by mini-css-extract-plugin
export default {"main":"HomeButton_main__4rQsl","logo":"HomeButton_logo__cJHfM"};